
import React, { useState, useMemo } from 'react';

import styles from '../../styles/MateriasStyles/PantallaDeTareas.v2.module.css';
import Pagination from '../../components/Pagination.tsx';
import { usePermissions } from '../../hooks/usePermissions';


const SeccionesTable = ({ data = [], loading = false, onEdit, onDelete }) => {
  const [page, setPage] = useState(1);
  const pageSize = 8;
  const filtered = useMemo(() => data, [data]);
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const paginated = filtered.slice((page - 1) * pageSize, page * pageSize);
  
  // Permisos del módulo Catálogos
  const { canEdit, canDelete } = usePermissions();
  const puedeEditar = canEdit('Catálogos');
  const puedeEliminar = canDelete('Catálogos');

  const safeText = (value) => {
    if (value === null || value === undefined) return '—';
    if (typeof value === 'string' || typeof value === 'number') return String(value);
    return '—';
  };
  const safeEstado = (estado) => {
    if (!estado) return 'INACTIVO';
    if (typeof estado === 'string') {
      return estado.toUpperCase() === 'ACTIVO' ? 'ACTIVO' : 'INACTIVO';
    }
    return 'INACTIVO';
  };

  const gridCols = 'minmax(210px,1fr) minmax(120px,0.8fr) minmax(120px,0.7fr) minmax(120px,0.7fr)';

  const ActionButtons = ({ row }) => (
    <div className={styles.actionButtons}>
      {puedeEditar && (
        <button aria-label="Editar" className={styles.actionButton} onClick={() => onEdit?.(row)}>
          <img
            src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/83eacec9f1f974b33615bbc95aea7ff7b2d13b0e?placeholderIfAbsent=true"
            alt="Editar"
            className={styles.actionIcon}
          />
        </button>
      )}
      {puedeEliminar && (
        <button aria-label="Eliminar" className={styles.actionButton} onClick={() => onDelete?.(row.id)}>
          <img
            src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/bef20ed4bd5293db48e37df8e511dca0fed7db2e?placeholderIfAbsent=true"
            alt="Eliminar"
            className={styles.actionIcon}
          />
        </button>
      )}
      {!puedeEditar && !puedeEliminar && (
        <span style={{ color: '#999', fontSize: '12px' }}>Solo lectura</span>
      )}
    </div>
  );

  const Header = () => (
    <div className={styles.tableHeader}>
      <div className={styles.tableTitle}>
        <div className={styles.tableTitleIcon}>
          <div className={styles.iconContainerOrange}><span>📚</span></div>
        </div>
        <h2 className={styles.tableTitleText}>Secciones Académicas</h2>
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className={styles.tableContainer} style={{ position: 'relative', zIndex: 1 }}>
        <Header />
      </div>
    );
  }

  return (
    <div className={styles.tableContainer} style={{ position: 'relative', minHeight: '320px', zIndex: 1 }}>
      <Header />

      <div className={styles.tableHeaderRow} style={{ gridTemplateColumns: gridCols }}>
        <span className={styles.columnHeader}>Sección</span>
        <span className={styles.columnHeader}>Código</span>
        <span className={styles.columnHeader}>Estado</span>
        <span className={styles.columnHeader + ' ' + styles.stickyActionsHeader}>Acciones</span>
      </div>

      <div className={styles.tableBody}>
        {paginated.length === 0 ? (
          <div className={styles.tableRow} style={{ gridTemplateColumns: gridCols }}>
            <span className={styles.cellData} colSpan={4}>Sin resultados.</span>
          </div>
        ) : paginated.map((s, idx) => (
          <div
            key={String(s.id) || idx}
            className={styles.tableRow}
            style={{ gridTemplateColumns: gridCols }}
          >
            <span className={styles.cellData}>{safeText(s.nombre)}</span>
            <span className={styles.cellData}>{safeText(s.codigo)}</span>
            <div className={styles.statusCell}>
              <div className={safeEstado(s.estado) === 'ACTIVO' ? styles.statusActive : styles.statusInactive}>
                <span>{safeEstado(s.estado)}</span>
              </div>
            </div>
            <div className={styles.actionButtons + ' ' + styles.stickyActionsCell}>
              <ActionButtons row={s} />
            </div>
          </div>
        ))}
      </div>

      {/* Paginación global */}
      {totalPages > 1 && (
        <Pagination
          page={page}
          totalPages={totalPages}
          onPageChange={setPage}
          className={styles.paginationWrapper}
        />
      )}
    </div>
  );
};

export default SeccionesTable;
